import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Gamepad2 } from "lucide-react";
import { intelliDocSuiteCategories } from "../../config/navigation";
import { useModuleAccess } from "../../hooks/useModuleAccess";

/**
 * Use buttons + in-memory navigate, not <a href> links. Office task panes replace
 * window.alert and block normal anchor navigation; React Router <Link> can trigger that.
 */
export const IntelliDocSuiteHome = () => {
  const navigate = useNavigate();
  const { canContracts, canPrizeRules } = useModuleAccess();

  const visibleCards = useMemo(
    () =>
      intelliDocSuiteCategories.filter((card) => {
        if (card.id === "contractiq") return canContracts;
        if (card.id === "prizelogic") return canPrizeRules;
        return false;
      }),
    [canContracts, canPrizeRules],
  );

  return (
    <div className="space-y-4">
      <div className="py-4">
        <h2 className="text-lg font-semibold text-gray-900">Welcome to IntelliDocSuite</h2>
        <p className="text-sm text-gray-600 mt-1">Select a category to get started</p>
      </div>
      {visibleCards.length === 0 ? (
        <p className="text-sm text-gray-600">
          No modules are available for your account. Contact your administrator if you need access.
        </p>
      ) : (
        <div className="space-y-3">
          {visibleCards.map((card) => {
            const isContractIQ = card.id === "contractiq";
            return (
              <button
                key={card.id}
                type="button"
                onClick={() => {
                  queueMicrotask(() => navigate(card.route));
                }}
                className={`flex w-full items-center gap-4 rounded-xl border-2 p-4 text-left transition-colors hover:border-primary ${isContractIQ ? "border-primary/30 bg-welcome-contractiq" : "border-violet-400/50 bg-welcome-prizelogic"
                  }`}
              >
                <div
                  className={`flex h-12 w-12 items-center justify-center rounded-lg ${isContractIQ ? "bg-welcome-contractiq text-primary" : "bg-welcome-prizelogic text-violet-600"
                    }`}
                >
                  {isContractIQ ? <FileText className="h-6 w-6" /> : <Gamepad2 className="h-6 w-6" />}
                </div>
                <div>
                  <p className="text-base font-semibold text-gray-900 mb-1">{card.title}</p>
                  <p className="text-sm text-gray-600">{card.description}</p>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
